import { handleAuthorization, handleOkResponseJson, handleBadRequest400 } from "./handlers"
import { obterToken } from "./loginService"
import * as axios from 'axios';

export default {
    obterImplementosAsync,
    enviarImplementoAsync,
    editarImplementoAsync,
    downloadLista
}

export const obterImplementosAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Implemento/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarImplementoAsync = async (nome, descricao, dataAquisicao, valorAquisicao, nfAquisicao, dataVenda, valorVenda, nfVenda) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ nome, descricao, dataAquisicao, valorAquisicao, nfAquisicao, dataVenda, valorVenda, nfVenda })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Implemento`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}

export const enviarImplementosAsync = async (implementos) => {

    const url = `${process.env.VUE_APP_API_URL}/Implemento`;
    const requestOptions = {
        headers: { 'Authorization': 'bearer ' + obterToken() },
    };
    let formData = new FormData();

    Array.from(Array(implementos.length).keys()).map((x) => {
        if (implementos[x].fileNfCompra != null) {
            formData.append('fileNfCompra', implementos[x].fileNfCompra);
        }
        if (implementos[x].fileNfVenda != null) {
            formData.append('fileNfVenda', implementos[x].fileNfVenda);
        }
    });

    formData.append('ImplementoDataModel', JSON.stringify(implementos, replacer));
    try {
        return axios.post(url, formData, requestOptions)
            .then(handleAuthorization)
            .then(handleBadRequest400);
    } catch (e) {
        alert(e.message);
    }

    /*const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify(implementos, replacer)
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Implemento`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);*/
}

export const editarImplementoAsync = async (id, nome, descricao, dataAquisicao, valorAquisicao, nfAquisicao, dataVenda, valorVenda, nfVenda, ativo) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, nome, descricao, dataAquisicao, valorAquisicao, nfAquisicao, dataVenda, valorVenda, nfVenda, ativo })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Implemento/atualizar`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}

export function downloadLista() {
    try {
        return axios({
            url: `${process.env.VUE_APP_ROOT_API}/Implemento/downloadImplementos`,
            method: 'GET',
            responseType: 'blob',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        }).catch(() => {
            return { status: false };
        })
            .then((response) => {
                if (response.status === false)
                    return response;
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'implementos' + '.xlsx');
                document.body.appendChild(fileLink);

                fileLink.click();
            });
    } catch (e) {
        throw e;
    }
}

function replacer(key, value) {
    if (key == "index" || key == "fileNfCompra" || key == "fileNfVenda") return undefined;
    else return value;
}